
jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});


window.onscroll = function () { //myFunction() 
};
var header = document.getElementById("header");
if (header != null) {
    var sticky = header.offsetTop;
}
function myFunction() {
    if (window.pageYOffset > sticky) {
        header.classList.add("fixed");

    } else {
        header.classList.remove("fixed");
    }
}


var lazyLoadInstance = null;

function lazyloader() {
    lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    new LazyLoad({
        elements_selector: "iframe.lazy, video.lazy, div.lazy, section.lazy, button.lazy,header.lazy"
    });
}


/* ── Image-CTA cards: scoop corners + 3D tilt ─────────── */
(function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-scoop-card]').forEach(function (card) {
        var tiltX = 0, tiltY = 0;

        function applyScoop(open) {
            var k = card.offsetWidth / 909;
            card.style.setProperty('--scoop', (open ? 92 * k : 0).toFixed(2) + 'px');
            var base = 'translateY(' + (open ? -10 : 0) + 'px)';
            if (!reduce && open) {
                base += ' perspective(1400px) rotateX(' + (-tiltY * 7).toFixed(2) + 'deg) rotateY(' + (tiltX * 7).toFixed(2) + 'deg)';
            }
            card.style.borderRadius = open ? '0px' : (16 * (card.offsetWidth / 909)).toFixed(2) + 'px';
            card.style.transform = open ? base : '';
        }

        applyScoop(false);

        card.addEventListener('mouseenter', function () { applyScoop(true); });

        card.addEventListener('mouseleave', function () {
            tiltX = tiltY = 0;
            applyScoop(false);
        });

        if (!reduce) {
            card.addEventListener('pointermove', function (e) {
                var r = card.getBoundingClientRect();
                tiltX = (e.clientX - r.left) / r.width - 0.5;
                tiltY = (e.clientY - r.top) / r.height - 0.5;
                applyScoop(true);
            });
        }
    });
}());

/* ── Horizontal scroll strip (.hscroll-outer) ───────────
   Reusable: any page can use .hscroll-outer + .hscroll-track.
   Supports multiple instances on the same page.
   Outer height is calculated from track scrollWidth so vertical scroll
   distance exactly matches horizontal travel. Lerp smooths the pan.
 ──────────────────────────────────────────────────────── */
(function () {
    var outers = document.querySelectorAll('.hscroll-outer');
    if (!outers.length) return;

    function initInstance(outer) {
        var track = outer.querySelector('.hscroll-track');
        if (!track) return;

        var curX = 0, tarX = 0, raf = null;

        function isDesktop() { return window.innerWidth >= 1024; }

        function resize() {
            if (!isDesktop()) {
                outer.style.height = '';
                track.style.transform = '';
                curX = tarX = 0;
                return;
            }
            var maxX = track.scrollWidth - window.innerWidth;
            outer.style.height = (window.innerHeight + Math.max(0, maxX)) + 'px';
        }

        function getTarget() {
            if (!isDesktop()) return 0;
            var scrolled = -outer.getBoundingClientRect().top;
            var total = outer.offsetHeight - window.innerHeight;
            if (total <= 0) return 0;
            var clamped = Math.min(Math.max(scrolled, 0), total);
            return (clamped / total) * (track.scrollWidth - window.innerWidth);
        }

        function lerp(a, b, t) { return a + (b - a) * t; }

        function tick() {
            curX = lerp(curX, tarX, 0.09);
            track.style.transform = 'translateX(-' + curX.toFixed(2) + 'px)';
            if (Math.abs(tarX - curX) > 0.4) {
                raf = requestAnimationFrame(tick);
            } else {
                curX = tarX;
                raf = null;
            }
        }

        function onScroll() {
            if (!isDesktop()) return;
            tarX = getTarget();
            if (!raf) raf = requestAnimationFrame(tick);
        }

        resize();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', function () {
            resize();
            tarX = curX = getTarget();
            if (isDesktop()) track.style.transform = 'translateX(-' + curX + 'px)';
        }, { passive: true });

        onScroll();
    }

    outers.forEach(initInstance);
}());

/* ── Gallery inner page: category filter ────────────────
   Select box (#gallery-filter) filters .gallery-grid-item
   elements by their data-category attribute.
 ──────────────────────────────────────────────────────── */
(function ($) {
    var $select = $('#gallery-filter');
    if (!$select.length) return;

    $select.on('change', function () {
        var val = $(this).val();
        var $items = $('.gallery-grid-item');

        if (val === 'all') {
            $items.fadeIn(200);
        } else {
            $items.each(function () {
                if ($(this).data('category') === val) {
                    $(this).fadeIn(200);
                } else {
                    $(this).fadeOut(150);
                }
            });
        }
    });
}(jQuery));

/* ── FAQ accordion ───────────────────────────────────── */
(function () {
    var faq = document.querySelector('.about-faq, .faq-section');
    if (!faq) return;

    function openItem(idx) {
        var item = faq.querySelector('.faq-item[data-index="' + idx + '"]');
        var answer = faq.querySelector('.faq-answer[data-answer="' + idx + '"]');
        if (!item || !answer) return;
        answer.style.maxHeight = answer.scrollHeight + 'px';
        item.querySelector('.faq-icon-plus').classList.add('hidden');
        item.querySelector('.faq-icon-minus').classList.remove('hidden');
        item.querySelector('.faq-icon').classList.add('bg-black/50', 'text-white', 'border-transparent');
    }

    function closeAll() {
        faq.querySelectorAll('.faq-answer').forEach(function (a) { a.style.maxHeight = '0px'; });
        faq.querySelectorAll('.faq-item').forEach(function (it) {
            it.querySelector('.faq-icon-plus').classList.remove('hidden');
            it.querySelector('.faq-icon-minus').classList.add('hidden');
            it.querySelector('.faq-icon').classList.remove('bg-black/50', 'text-white', 'border-transparent');
        });
    }

    openItem(0);

    faq.querySelectorAll('.faq-toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var idx = btn.dataset.index;
            var answer = faq.querySelector('.faq-answer[data-answer="' + idx + '"]');
            var isOpen = answer.style.maxHeight !== '0px' && answer.style.maxHeight !== '';
            closeAll();
            if (!isOpen) openItem(idx);
        });
    });
}());


$(document).ready(function () {
    lazyloader();

    $('#toggleMenu').on('click', function () {
        $('.primary-menu-wrapper').toggleClass('openmenu');
    });

    $('.menuCloseIcon').on('click', function () {
        $('.primary-menu-wrapper').removeClass('openmenu');
    });

    // Mobile submenu: inject toggle buttons and handle tap-to-expand
    $('.nav-item.dropdown').each(function () {
        $(this).find('> .nav-link').after(
            '<button class="submenu-toggle" aria-label="Toggle submenu" aria-expanded="false">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 9 5" fill="none">' +
            '<path d="M4.40375 4.40375L0 0H8.8075L4.40375 4.40375Z" fill="currentColor"/>' +
            '</svg></button>'
        );
    });

    $(document).on('click', '.submenu-toggle', function () {
        var $item = $(this).closest('.nav-item.dropdown');
        var isOpen = $item.hasClass('open');
        $('.nav-item.dropdown').removeClass('open').find('.submenu-toggle').attr('aria-expanded', 'false');
        if (!isOpen) {
            $item.addClass('open').find('> .submenu-toggle').attr('aria-expanded', 'true');
        }
    });


    /**********************footer menu ********************** */

    $('.home-pagelist-slider').slick({
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                }
            },

        ]
    });

    /* set <source data-src> → src and call load() to begin buffering */
    function preloadSlideVideos($slides) {
        $slides.find('source[data-src]').each(function () {
            var $src = $(this);
            if ($src.attr('src')) return;
            $src.attr('src', $src.data('src'));
            $src.closest('video')[0].load();
        });
    }

    /* play all videos inside the given slides */
    function playSlideVideos($slides) {
        $slides.find('video').each(function () {
            if (this.paused) this.play().catch(function () { });
        });
    }

    /* pause all videos inside the given slides */
    function pauseSlideVideos($slides) {
        $slides.find('video').each(function () {
            if (!this.paused) this.pause();
        });
    }

    $('.video-slider')
        .on('init', function (e, slick) {
            var $active = slick.$slides.filter('.slick-active');
            preloadSlideVideos($active);
            playSlideVideos($active);
        })
        .on('beforeChange', function (e, slick, cur, next) {
            /* preload the incoming slide(s) before the transition starts */
            preloadSlideVideos(slick.$slides.eq(next));
            if (slick.options.slidesToShow > 1) {
                preloadSlideVideos(slick.$slides.eq((next + 1) % slick.slideCount));
            }
        })
        .on('afterChange', function (e, slick) {
            /* once transition is done: play active slides, pause the rest */
            slick.$slides.each(function (i, slide) {
                var $slide = $(slide);
                if ($slide.hasClass('slick-active')) {
                    preloadSlideVideos($slide);
                    playSlideVideos($slide);
                } else {
                    pauseSlideVideos($slide);
                }
            });
        })
        .slick({
            slidesToShow: 3,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            speed: 500,
            cssEase: 'linear',
            infinite: false,
            focusOnSelect: false,
            dots: false,
            variableWidth: true,
            nextArrow: $(".video-slick-next"),
            prevArrow: $(".video-slick-prev"),
            responsive: [
                {
                    breakpoint: 768,
                    settings: { slidesToShow: 1 }
                }
            ]
        });
    $('.reviews-slider').slick({
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {

                    slidesToShow: 1
                }
            },

        ]
    });

    /* ── Cultural: video auto-scroll ticker (pause on hover) ── */
    if ($('.cultural-video-ticker').length) {
        $('.cultural-video-ticker').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 6000,
            cssEase: 'linear',
            pauseOnHover: true,
            pauseOnFocus: false,
        });
    }

    /* ── Cultural / Packages: video slider ───────────────── */
    if ($('.cultural-video-slider').length) {
        $('.cultural-video-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            speed: 700,
            cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            centerMode: true,
            centerPadding: '12%',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '6%',
                    }
                }
            ]
        });
    }

    /* ── Packages: showcase slider ───────────────────────── */
    if ($('.showcase-slider').length) {
        $('.showcase-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.showcase-prev'),
            nextArrow: $('.showcase-next'),
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            lazyLoad: 'ondemand',
            speed: 700,
            cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 1 } }
            ]
        });
        lazyLoadInstance.update();
    }

    /* ── Packages: event categories slider ───────────────── */
    if ($('.events-slider').length) {
        $('.events-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.events-prev'),
            nextArrow: $('.events-next'),
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            lazyLoad: 'ondemand',
            variableWidth: true,
            speed: 700,
            cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            responsive: [
                { breakpoint: 1024, settings: { variableWidth: false, slidesToShow: 1 } }
            ]
        });
        lazyLoadInstance.update();
    }

    /* ── Hero intro arch image fade slider (hospitality + menu) ── */
    if ($('.hero-intro-image-slider').length) {
        $('.hero-intro-image-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 1000,
            cssEase: 'ease-in-out',
            infinite: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false,
        });
    }

    /* ── Menu: food ticker slider (continuous auto-scroll) ── */
    if ($('.food-ticker-slider').length) {
        $('.food-ticker-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            cssEase: 'linear',
            infinite: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            variableWidth: true,
            lazyLoad: 'ondemand',
        });
        lazyLoadInstance.update();
    }

    /* ── Events: event listing slider ── */
    if ($('.event-listing-slider').length) {
        $('.event-listing-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.event-listing-prev'),
            nextArrow: $('.event-listing-next'),
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            variableWidth: true,
            lazyLoad: 'ondemand',
            centerMode: false,
        });
        lazyLoadInstance.update();
    }

    /* ── Events: event showcase slider ── */
    if ($('.event-showcase-slider').length) {
        $('.event-showcase-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.event-showcase-prev'),
            nextArrow: $('.event-showcase-next'),
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            responsive: [
                { breakpoint: 1280, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 1 } },
            ],
        });
    }

    // Gallery scroll reveal — Slick is initialised here so it measures at real width
    function initGallerySlider() {
        var $slider = $('.gallery-slider');
        if (!$slider.length || $slider.hasClass('slick-initialized')) return;

        // Show at height 0 first so Slick can measure slide widths
        $slider.css({ display: 'block', overflow: 'hidden', maxHeight: '0px' });

        $slider.slick({
            slidesToShow: 5,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            cssEase: 'linear',
            infinite: true,
            focusOnSelect: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            dots: false,
            variableWidth: true,
            responsive: [
                { breakpoint: 768, settings: { slidesToShow: 1 } }
            ]
        });

        // Trigger lazy load for newly visible images
        if (lazyLoadInstance) lazyLoadInstance.update();

        // Animate height 0 → natural height
        var naturalH = $slider[0].scrollHeight + 'px';
        $slider[0].offsetHeight; // force reflow
        $slider.css({ transition: 'max-height 2.5s cubic-bezier(0.16,1,0.3,1) 0.15s', maxHeight: naturalH });

        // Clean up inline constraints after transition
        setTimeout(function () {
            $slider.css({ maxHeight: '', overflow: '', transition: '' });
        }, 2800);
    }

    function checkGalleryReveal() {
        var $gallery = $('section.gallery');
        if ($gallery.length && !$gallery.hasClass('in-view')) {
            var scrollTop = $(window).scrollTop();
            var windowHeight = $(window).height();
            var galleryTop = $gallery.offset().top;

            if (scrollTop + windowHeight * 0.5 >= galleryTop) {
                $gallery.addClass('in-view');
                initGallerySlider();
                $(window).off('scroll.gallery');

            }
        }
    }

    $(window).on('scroll.gallery', checkGalleryReveal);
    setTimeout(checkGalleryReveal, 4000); // check on load in case already in view



    // Packages slider
    if ($('.packages-slider').length) {
        $('.packages-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.packages-prev'),
            nextArrow: $('.packages-next'),
            lazyLoad: 'ondemand',
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: false,
            speed: 600,
            cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            infinite: true,
            dots: false,
            variableWidth: true,
            centerMode: true,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } }
            ]
        });
    }

    /* ── Blog: copy link ──────────────────────────────────── */
    if ($('.blog-copy-link').length) {
        $('.blog-copy-link').on('click', function () {
            var $btn = $(this);
            var url = $btn.data('url');
            if (!url) return;
            navigator.clipboard.writeText(url).then(function () {
                $btn.find('.copy-label').text('Copied!');
                setTimeout(function () {
                    $btn.find('.copy-label').text('Copy link');
                }, 2000);
            });
        });
    }

});

/* ── Header: hide nav + CTA when footer TOP enters viewport ─
   Triggers exactly when the footer's top edge crosses the
   viewport bottom — not when any stray pixel is visible.
 ──────────────────────────────────────────────────────── */
(function () {
    var nav = document.getElementById('headerNav');
    var footer = document.querySelector('footer');
    if (!nav || !footer) return;

    function check() {
        nav.classList.toggle('header-at-footer', footer.getBoundingClientRect().top <= nav.offsetHeight);
    }

    window.addEventListener('scroll', check, { passive: true });
    check();
}());

/* ── Header logo: dark on light-bg sections ─────────────
   Checks computed bg colour of every <section> once on load,
   then on scroll detects which section is behind the header
   and toggles .header-light-bg on #headerNav accordingly.
 ──────────────────────────────────────────────────────── */
(function () {
    var header = document.getElementById('headerNav');
    if (!header) return;

    var lightSections = Array.from(document.querySelectorAll('section')).filter(function (el) {
        var m = getComputedStyle(el).backgroundColor.match(/\d+/g);
        return m && (0.299 * +m[0] + 0.587 * +m[1] + 0.114 * +m[2]) > 128;
    });

    if (!lightSections.length) return;

    function update() {
        var y = header.getBoundingClientRect().bottom;
        var light = lightSections.some(function (s) {
            var r = s.getBoundingClientRect();
            return r.top <= y && r.bottom > y;
        });
        header.classList.toggle('header-light-bg', light);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
}());

/* ── Blog: AJAX category filter ─────────────────────── */
(function () {
    var filterBar = document.querySelector('[data-blog-filter]');
    var results = document.getElementById('blog-results');
    if (!filterBar || !results || typeof chBlog === 'undefined') return;

    var currentCat = parseInt((filterBar.querySelector('.blog-pill--active') || {}).dataset && filterBar.querySelector('.blog-pill--active').dataset.cat, 10) || 0;
    var currentPage = 1;
    var loading = false;

    function loadPosts(catId, paged) {
        if (loading) return;
        loading = true;
        results.style.opacity = '0.4';
        results.style.pointerEvents = 'none';

        var body = new URLSearchParams({ action: 'blog_filter', cat_id: catId, paged: paged });

        fetch(chBlog.ajaxurl, { method: 'POST', body: body })
            .then(function (r) { return r.json(); })
            .then(function (res) { if (res.success) results.innerHTML = res.data.html; })
            .catch(function () { })
            .finally(function () {
                loading = false;
                results.style.opacity = '';
                results.style.pointerEvents = '';
            });
    }

    // Pill clicks
    filterBar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cat]');
        if (!btn) return;
        var catId = parseInt(btn.dataset.cat, 10);
        if (catId === currentCat) return;
        currentCat = catId;
        currentPage = 1;
        filterBar.querySelectorAll('[data-cat]').forEach(function (b) {
            b.classList.toggle('blog-pill--active', b === btn);
        });
        loadPosts(currentCat, currentPage);
    });

    // Pagination clicks (delegated — #blog-results innerHTML is replaced)
    results.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-page]');
        if (!btn) return;
        currentPage = parseInt(btn.dataset.page, 10);
        loadPosts(currentCat, currentPage);
    });
}());

/* ── Venue cards: scoop corners + 3D tilt (ported from VenueCard.tsx) ────── */
(function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function applyShape(card, imgWrap, open) {
        var k = card.offsetWidth / 909;
        imgWrap.style.setProperty('--scoop', (open ? 92 * k : 0).toFixed(2) + 'px');
        imgWrap.style.inset = (open ? 24 * k : 0).toFixed(2) + 'px';
        card.style.borderRadius = ((open ? 40 : 16) * k).toFixed(2) + 'px';
    }

    document.querySelectorAll('[data-venue-card]').forEach(function (root) {
        var card = root.querySelector('.ch-venue-card');
        var imgWrap = card && card.querySelector('.ch-venue-image');
        if (!card || !imgWrap) return;

        // Set clean initial border-radius keyed to actual card width
        applyShape(card, imgWrap, false);

        var tiltX = 0, tiltY = 0;

        function buildTransform(open) {
            var ty = open ? -10 : 0;
            if (reduce) return 'translateY(' + ty + 'px)';
            return 'translateY(' + ty + 'px) perspective(1400px) rotateX(' +
                (-tiltY * 7).toFixed(2) + 'deg) rotateY(' +
                (tiltX * 7).toFixed(2) + 'deg)';
        }

        card.addEventListener('mouseenter', function () {
            applyShape(card, imgWrap, true);
            card.classList.add('is-open');
            card.style.transform = buildTransform(true);
        });

        card.addEventListener('mouseleave', function () {
            tiltX = tiltY = 0;
            applyShape(card, imgWrap, false);
            card.classList.remove('is-open');
            card.style.transform = '';
        });

        if (!reduce) {
            card.addEventListener('pointermove', function (e) {
                if (!card.classList.contains('is-open')) return;
                var r = card.getBoundingClientRect();
                tiltX = (e.clientX - r.left) / r.width - 0.5;
                tiltY = (e.clientY - r.top) / r.height - 0.5;
                card.style.transform = buildTransform(true);
            });
        }
    });
}());